// extracted by mini-css-extract-plugin
export default {"descriptionText":"descriptionText___t5rAc"};